const STORAGE_KEY_PREFIX = 'group_client_';

function generateUuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export interface GroupClientIdentity {
  identity: string;
  displayName: string;
}

/**
 * Returns a stable identity and display name for a group therapy participant (client).
 * Persists in sessionStorage per room so refresh keeps the same participant.
 */
export function getOrCreateGroupClientId(roomCode: string): GroupClientIdentity {
  const key = `${STORAGE_KEY_PREFIX}${roomCode}`;
  try {
    const stored = sessionStorage.getItem(key);
    if (stored) {
      const parsed = JSON.parse(stored) as GroupClientIdentity;
      if (parsed.identity && parsed.displayName) return parsed;
    }
  } catch {
    // ignore invalid stored value
  }

  const identity = `client-${generateUuid()}`;
  const displayName = `Участник-${identity.slice(-6)}`;
  const value: GroupClientIdentity = { identity, displayName };
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota errors
  }
  return value;
}

/**
 * Обновляет отображаемое имя участника групповой терапии (имя и фамилия).
 * Если запись по комнате уже есть — обновляет displayName; иначе создаёт новую с переданным именем.
 */
export function setGroupClientDisplayName(roomCode: string, displayName: string): void {
  const key = `${STORAGE_KEY_PREFIX}${roomCode}`;
  const trimmed = displayName?.trim() || '';
  try {
    const stored = sessionStorage.getItem(key);
    if (stored) {
      const parsed = JSON.parse(stored) as GroupClientIdentity;
      if (parsed.identity) {
        sessionStorage.setItem(key, JSON.stringify({ ...parsed, displayName: trimmed || parsed.displayName }));
        return;
      }
    }
  } catch {
    // ignore
  }
  const identity = `client-${generateUuid()}`;
  sessionStorage.setItem(key, JSON.stringify({ identity, displayName: trimmed || `Участник-${identity.slice(-6)}` }));
}
